import Typography from '@material-ui/core/Typography';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';

import i18n from '../../i18n';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const LongTextButton = ({short, long, tooltip, classes}) => {
    const [open, setOpen] = useState(false);
    const tooltipText = tooltip || long.substring(0, 1000) + (long.length > 1000 ? '...' : '');
    const shortText = short + (short.length < long.length ? '...' : '');

    return (
        <React.Fragment>
            <Button onClick={() => setOpen(true)} className={classes.button} color={'primary'}>
                <Tooltip title={tooltipText}>
                    <span>{shortText}</span>
                </Tooltip>
            </Button>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={() => setOpen(false)}
            >
                <div className={classes.paper} style={getModalStyle()}>
                    <Typography variant="subtitle1" id="simple-modal-description" className={classes.content}>
                        {long}
                    </Typography>
                    <Button onClick={() => setOpen(false)} color={'primary'} className={classes.buttonClose}>
                        <Icon>
                            keyboard_arrow_left
                        </Icon>
                        {i18n.get('default.close')}
                    </Button>
                </div>
            </Modal>
        </React.Fragment>
    );
};

const styles = theme => ({
    content: {
        textOverflowY: 'auto',
    },
    paper: {
        position: 'absolute',
        width: 'calc(100vw - 40px)',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
        maxHeight: '80vh',
        overflowY: 'auto',
    },
    button: {
        textAlign: 'left',
        textTransform: 'inherit',
        maxWidth: '100%',
    },
    buttonClose: {
        width: '100%',
    },
});

export default withStyles(styles)(LongTextButton);
